<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-QiangWang`]" width="1em" height="1em" v-bind="$attrs"><path d="M26.2929 17.2929C26.6834 16.9024 27.3166 16.9024 27.7071 17.2929L33.7071 23.2929C33.8085 23.3943 33.8836 23.5121 33.9324 23.6378C33.9696 23.7336 33.9925 23.8366 33.9984 23.9441C33.9991 23.9556 33.9995 23.9672 33.9998 23.9788C33.9999 23.9859 34 23.9929 34 24C34 24.032 33.9985 24.064 33.9954 24.0959C33.9867 24.1865 33.9657 24.2762 33.9324 24.3622C33.8836 24.4879 33.8085 24.6057 33.7071 24.7071L27.7071 30.7071C27.3166 31.0976 26.6834 31.0976 26.2929 30.7071C25.9024 30.3166 25.9024 29.6834 26.2929 29.2929L30.5858 25H15C14.4477 25 14 24.5523 14 24C14 23.4477 14.4477 23 15 23H30.5858L26.2929 18.7071C25.9024 18.3166 25.9024 17.6834 26.2929 17.2929Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24Z"/></svg>
</template>
<script>

export default {
  name: 'IconQiangWang',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
